
import "/app/src/components/AvatarDropdown/index.module.less?modules";
export default {"trigger": `trigger-lYRH8VYf`,"root": `root-EM_33CuN`,"avatar": `avatar-XGtiosX_`,"name": `name-ZOO0faPT`}
